/// AXIOS ///
import axios from "axios";
import { AxiosError } from "axios";
/// REDUX ///
import { Dispatch } from "redux";
import { RootState } from "api/reducers";
/// ACTION ///
import { Action } from "api/action_types/sketch";
import { Action as AuthAction } from "api/action_types/authentication";
///ACTION TYPES ///
import { ActionType } from "api/action_types/sketch";
import { ActionType as AuthActionType } from "api/action_types/authentication";
/// URLS ///
import { url_prefix } from "settings";
import { cut_shape_url } from "../endpoint";

export const getCutShapes = (quote?: number | string, fabricator_quote?: number | string) => {
  return async (dispatch: Dispatch<Action | AuthAction>, getState: () => RootState) => {
    const { user } = getState().authentication;

    dispatch({
      type: ActionType.SHAPES_LOADING
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${user.token}`
      }
    }

    let url = `${url_prefix}${cut_shape_url}/?`;

    if (quote) {
      url += `quote=${quote}&`;
    }

    if (fabricator_quote) {
      url += `fabricator_quote=${fabricator_quote}&`;
    }

    try {
      const { data } = await axios.get(url, config);

      dispatch({
        type: ActionType.GET_CUT_SHAPES_SUCCESS,
        payload: data
      });
    }
    catch (err) {
      if (err instanceof AxiosError) {
        dispatch({
          type: ActionType.SHAPES_ERROR,
          payload: err.message
        });
        if (err && err.response && err.response.status === 401) {
          dispatch({
            type: AuthActionType.AUTH_FAILED
          });
        }
      }
    }
  }
}
